import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let UndoSendOption: LazyOption = createLazyOption(
    {
        key: 'undoSend',
        titleStringKey: 'optionTitle_undoSend',
        searchTermsStringKey: 'optionTitle_undoSend',
        isHidden: () => !isFeatureEnabled('cmp-delaySend'),
    },
    lazyFullModule,
    m => m.default
);
export default UndoSendOption;
